import { createAction } from 'redux-act';

export interface IUnsubscribeFromEmails {
	email: string;
	token: string;
}

export const unsubscribeFromEmails = createAction<IUnsubscribeFromEmails>();
export const unsubscribeFromEmailsSuccess = createAction();
export const unsubscribeFromEmailsFailed = createAction();